<template>
  <v-dialog v-model="isOpen" width="60%" persistent>
    <v-card>
      <v-card-title class="headline grey lighten-3 py-4">
        Editar Registro
      </v-card-title>

      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.Nombre"
                  label="Nombre"
                  :disabled="data.Tipo === 'Jurídica'"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.Apellido"
                  label="Apellido"
                  :disabled="data.Tipo === 'Jurídica'"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.RazonSocial"
                  label="Razón Social"
                  :disabled="data.Tipo === 'Física'"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="data.Email" label="Email" class="mb-4" />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.CUIT"
                  label="Número de CUIT"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.DNI"
                  label="Número de DNI"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.Telefono1"
                  label="Teléfono 1"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="data.Cbu" label="CBU" class="mb-4" />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="data.Operatoria"
                  label="Operatoria"
                  readonly
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="data.Tipo"
                  :items="TipoOptions"
                  label="Tipo"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="data.Garantia"
                  :items="tipoGarantias"
                  label="Garantía"
                  class="mb-4"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="data.Pagos"
                  :items="tipoPagos"
                  label="Pagos"
                  class="mb-4"
                />
              </v-col>
               <v-col cols="12" md="6">                          
        <v-select                                       
           v-model="data.Localidad"                      
            :items="localidades"                          
          item-text="localidad"                         
           item-value="localidad"                        
           label="Localidad"                             
          class="mb-4"                                  
          />                                              
     </v-col>    
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="closeModal">Cerrar</v-btn>
        <v-btn color="success" @click="guardarCambios">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: { type: Boolean },
    data: { type: Object, required: true },
    localidades: { type: Array, required: true },
  },
  data() {
    return {
      Operatoria: '',
      EstadoLegajo: '',
      Tipo: '',
      Nombre: '',
      Apellido: '',
      RazonSocial: '',
      DNI: '',
      CUIT: '',
      Telefono1: '',
      Telefono2: '',
      SectorProductivo: '',
      Email: '',
      Garantia: '',
      MontoDelCredito: '',
      FechaDeDesembolso: '',
      FechaDeInicio: '',
      PlazoDeCredito: '',
      PlazoDeGracia: '',
      Pagos: '',
      Cbu: '',
      Usuario: '',
      EmailUsuario: '',
      processing: false,
      checkboxStates: [],
      TipoOptions: [
        { value: 'Física', text: 'Física' },
        { value: 'Jurídica', text: 'Jurídica' },
      ],
      tipoGarantias: [
        { text: 'Personal', value: 'Personal' },
        { text: 'Pagaré', value: 'Pagaré' },
        { text: 'Fianza', value: 'Fianza' },
        { text: 'Hipotecaria', value: 'Hipotecaria' },
        { text: 'Prenda', value: 'Prenda' },
        { text: 'Cuyo aval', value: 'Cuyo Aval' },
      ],
      tipoPagos: [
        { text: 'Mensual', value: 'Mensual' },
        { text: 'Bimestral', value: 'Bimestral' },
        { text: 'Semestral', value: 'Semestral' },
        { text: 'Trimestral', value: 'Trimestral' },
        { text: 'Anual', value: 'Anual' },
      ],
    };
  },

  name: 'ModalImportarLegajo',
  methods: {
    closeModal() {
      this.$emit('update:isOpen', false);
    },
    verifyGarantia() {
      const value = this.data.Garantia;
      if (!this.garantias.includes(value)) {
        this.data.Garantía = this.garantias[0];
      }
      return value;
    },
    guardarCambios() {
      this.$emit('update:data', this.data);
      this.$emit('update:isOpen', false);
    },
  },

  created() {},
};
</script>
